module.exports = __webpack_public_path__ + "img/10_military.fedba162.png";